<template>
  <Drawer
    width="1000"
    v-model="drawerOpened"
    :title="openedSales.customer ? openedSales.customer.name : ''"
    @on-close="closeDrawer"
  >
    <Modal v-model="delPriceModel" @on-ok="delPriceMethod" @on-cancel="cancelDel">
      <p>您确认要删除此条价格记录吗？</p>
    </Modal>
    <div class="drawer-content">
      <div class="currentCost">
        <div class="sale-price cost">
          <div>售价（元）</div>
          <div class="price">
            {{
            price ? price : openedSales.price ? openedSales.price.price : 0
            }}
          </div>
        </div>
        <div class="freight cost">
          <div>运费（元）</div>
          <div class="price">
            {{
            transCost
            ? transCost
            : openedSales.transCost
            ? openedSales.transCost.cost
            : 0
            }}
          </div>
        </div>
        <div class="operation-cost cost">
          <div>业务费（元）</div>
          <div class="price">{{ promoFeeSum }}</div>
        </div>
        <div class="estAging-cost cost">
          <div>账龄（月）</div>
          <div class="price">{{ estAging }}</div>
        </div>
        <div class="transDist-cost cost">
          <div>运距（KM）</div>
          <div class="price">{{ transDist }}</div>
        </div>
      </div>
      <div class="dashed"></div>
      <div class="cost-records">
        <div class="sale-table table">
          <div>售价</div>
          <div class="top">
            <InputNumber controls-outside v-model="salePrice"></InputNumber>
            <Button type="primary" @click="addPrice('sales')">添加</Button>
          </div>
          <div class="table-wrapper" ref="tableWrapper">
            <Table
              border
              :height="tableHeight"
              :loading="tableLoading"
              :data="salesPriceRecordList"
              :columns="salesPriceColumns"
            >
              <template slot-scope="{ row }" slot="deleteBtn" style="padding-left: 0">
                <Icon
                  type="ios-remove-circle-outline"
                  class="deleteBtn"
                  @click="delPrice(row._id, 'salesPrice')"
                  size="23"
                />
              </template>
            </Table>
          </div>
        </div>
        <div class="freight-table table">
          <div>运费</div>
          <div class="top">
            <InputNumber controls-outside v-model="transPrice"></InputNumber>
            <Button type="primary" @click="addPrice('trans')">添加</Button>
          </div>
          <div class="table-wrapper" ref="tableWrapper">
            <Table
              border
              :height="tableHeight"
              :loading="tableLoading"
              :data="salesTransCostRecordList"
              :columns="salesTransPriceColumns"
            >
              <template slot-scope="{ row }" slot="deleteBtn" style="padding-left: 0">
                <Icon
                  type="ios-remove-circle-outline"
                  class="deleteBtn"
                  @click="delPrice(row._id, 'transPrice')"
                  size="23"
                />
              </template>
            </Table>
          </div>
        </div>
        <div class="operation-table table">
          <div class="top">
            <div>业务费</div>
            <Button :disabled="currentUser.superAdmin ? false : arrayIntersection(['ywf'], currentUser.simpleRole).length > 0 ? false : true" type="primary" @click="showSetPromoFeeModal()">设置</Button>
          </div>
          <div class="table-wrapper" ref="tableWrapper">
            <Table
              border
              :height="tableHeight"
              :loading="tableLoading"
              :data="currentPromoFeeList"
              :columns="promoFeeColumns"
            ></Table>
          </div>
          <Modal
            v-model="isShowSetPromoFeeModal"
            :title="
              openedSales.customer ? openedSales.customer.name + '业务费' : ''
            "
            :loading="setPromoFeeModalLoading"
            @on-ok="setPromoFee"
            @on-cancel="cancel"
            width="1300"
          >
            <div class="modal-wrap">
              <div class="table-wrapper" ref="tableWrapper">
                <div class="modalTitle" style="margin-bottom: 21px">
                  <div>当前业务费</div>
                  <div>
                    合计：{{
                    savePromoFeeSum ? savePromoFeeSum : promoFeeSum
                    }}元
                  </div>
                </div>
                <Table border :data="saveCurrentPromoFeeList" :columns="currentPromoFeeColumns"></Table>
              </div>
              <div class="table-wrapper" ref="tableWrapper">
                <div>
                  <div class="modalTitle">
                    <div>业务费列表</div>
                    <Button type="primary" @click="addPromoFee('fee')">添加</Button>
                    <Modal
                      v-model="addPromoFeeRecordModal"
                      title="添加业务费"
                      @on-ok="addPromoFeeRecord"
                      @on-cancel="cancel"
                      :mask-closable="false"
                      width="300px"
                    >
                      <div style="width: 300px; margin: auto">
                        <div>选择联系人</div>
                        <Select
                          v-model="selectCustomerContact"
                          placeholder="选择联系人..."
                          clearable
                          style="width: 250px"
                          filterable
                        >
                          <Option
                            v-for="item in customerContactList"
                            :value="item._id"
                            :key="item._id"
                          >{{ item.name }}</Option>
                        </Select>
                        <div>业务费</div>
                        <InputNumber v-model="promoFee" style="width: 250px" />
                      </div>
                    </Modal>
                  </div>
                </div>
                <Table
                  border
                  :data="salesPromoFeeRecordList"
                  :columns="promoFeeRecordsColumns"
                  height="340"
                  @on-selection-change="choosePromoFee"
                ></Table>
              </div>
              <div class="table-wrapper" ref="tableWrapper">
                <div>
                  <div class="modalTitle">
                    <div>客户联系人</div>
                    <Button type="primary" @click="addPromoFee('contact')">添加</Button>
                    <Modal
                      v-model="addCustomerContactModal"
                      title="添加客户联系人"
                      @on-ok="addCustomerContact"
                      @on-cancel="cancel"
                      width="300px"
                      :mask-closable="false"
                    >
                      <div style="width: 300px; margin: auto">
                        <Input
                          v-model="customerContact"
                          placeholder="输入联系人姓名..."
                          clearable
                          style="width: 250px"
                        />
                      </div>
                    </Modal>
                  </div>
                </div>
                <Table border :data="customerContactList" :columns="customerContactColumns" height='340'></Table>
              </div>
            </div>
          </Modal>
        </div>
        <div class="estAging-wrap">
          <div style="margin-bottom: 20px">
            <div>账龄</div>
            <div class="top">
              <InputNumber controls-outside v-model="estAging"></InputNumber>
              <Button type="primary" @click="setEstAging('sales')">设置</Button>
            </div>
          </div>
          <div>
            <div>运距</div>
            <div class="top">
              <InputNumber controls-outside v-model="transDist"></InputNumber>
              <Button type="primary" @click="setTransDist('sales')">设置</Button>
            </div>
          </div>
          <div>
            <div>备注</div>
            <div class="remark">
              <Input style="width: 320px" v-model="remark" type="textarea" placeholder="输入备注..." />
              <Button type="primary" @click="setRemark('sales')">保存</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Drawer>
</template>

<script>
import dayjs from "dayjs";
import { mapState, mapActions } from "vuex";
import { arrayIntersection } from "@/utils";

export default {
  name: "SalesCostDrawer",
  data() {
    return {
      drawerOpened: false,
      openedSales: {},
      delPriceModel: false,
      delId: undefined,
      delType: undefined,
      salePrice: null,
      transPrice: null,
      saveCurrentPromoFeeList: [],
      savePromoFeeSum: undefined,
      tableLoading: false,
      isShowSetPromoFeeModal: false,
      setPromoFeeModalLoading: true,
      addCustomerContactModal: false,
      addPromoFeeRecordModal: false,
      customerContact: undefined,
      selectCustomerContact: undefined,
      promoFee: null,
      transCost: undefined,
      price: undefined,
      estAging: null,
      transDist: null,
      remark: null,
      choosedPromoFee: [],
      salesPriceColumns: [
        {
          title: "价格",
          key: "price",
          width: 100,
          render: (h, params) => h("span", params.row.price)
        },

        {
          title: "日期",
          key: "date",
          width: 240,
          render: (h, params) =>
            h(
              "span",
              dayjs(params.row.startActiveDate).format("YYYY-MM-DD HH:mm")
            )
        },
        {
          title: " ",
          key: "deleteBtn",
          slot: "deleteBtn",
          align: "center",
          width: 58
        }
      ],
      salesTransPriceColumns: [
        {
          title: "价格",
          key: "price",
          render: (h, params) => h("span", params.row.cost)
        },
        {
          title: "日期",
          key: "date",
          render: (h, params) =>
            h(
              "span",
              dayjs(params.row.startActiveDate).format("YYYY-MM-DD HH:mm")
            )
        },
        {
          title: " ",
          key: "deleteBtn",
          slot: "deleteBtn",
          align: "center",
          width: 58
        }
      ],
      promoFeeColumns: [
        {
          title: "价格",
          key: "price",
          render: (h, params) => h("span", params.row.fee)
        },
        {
          title: "日期",
          key: "date",
          render: (h, params) =>
            h("span", dayjs(params.row.createdAt).format("YYYY-MM-DD HH:mm"))
        }
      ],
      currentPromoFeeColumns: [
        {
          title: "名字",
          key: "name",
          render: (h, params) => h("span", params.row.customerContact.name)
        },
        {
          title: "费用",
          key: "fee",
          align: "right",
          render: (h, params) => h("span", params.row.fee)
        }
      ],
      promoFeeRecordsColumns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "名字",
          key: "name",
          render: (h, params) => h("span", params.row.customerContact.name)
        },
        {
          title: "费用",
          key: "fee",
          align: "right",
          render: (h, params) => h("span", params.row.fee)
        }
      ],
      customerContactColumns: [
        {
          title: "名字",
          key: "name",
          align: "center",
          render: (h, params) => h("span", params.row.name)
        }
      ],
      tableHeight: 300
    };
  },
  computed: {
    ...mapState({
      // 售价
      salesPriceRecordList: state =>
        state.salesPriceRecord.salesPriceRecordList,
      // 运费
      salesTransCostRecordList: state =>
        state.salesTransCostRecord.salesTransCostRecordList,
      // 联系人
      customerContactList: state => state.customerContact.customerContactList,
      salesPromoFeeRecordList: state =>
        state.salesPromoFeeRecord.salesPromoFeeRecordList,
      currentPromoFeeList: state =>
        state.salesPromoFeeRecord.currentPromoFeeList,
      promoFeeSum: state => state.salesPromoFeeRecord.promoFeeSum,
      currentUser: state => state.auth.currentUser,
    })
  },
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    ...mapActions({
      getSalesPrice: "salesPriceRecord/getSalesPriceAction",
      deleteSalesPrice: "salesPriceRecord/deleteSalesPriceAction",
      createSalesPrice: "salesPriceRecord/createSalesPriceAction",
      getSalesTransPrice: "salesTransCostRecord/getSalesTransPriceAction",
      deleteTransCost: "salesTransCostRecord/deleteTransCostAction",
      createSalesTransPrice: "salesTransCostRecord/createSalesTransPriceAction",
      createSalesPromoFeeRecord:
        "salesPromoFeeRecord/createSalesPromoFeeRecordAction",
      getSalesPromoFee: "salesPromoFeeRecord/getSalesPromoFeeAction",
      getCurrentPromoFee: "salesPromoFeeRecord/getCurrentPromoFeeAction",
      setActivcePromoFee: "salesPromoFeeRecord/setActivcePromoFeeAction",
      createCustomerContact: "customerContact/createCustomerContactAction",
      getCustomerContact: "customerContact/getCustomerContactAction",
      updateSales: "sales/updateSalesAction",
      getSalesById: "sales/getSalesByIdAction"
    }),
    async openDrawer(sales) {
      this.remark = null;
      if (sales) {
        const data = await this.getSalesById(sales._id);
        if (data.remark) {
          this.remark = data.remark;
        }
      }
      this.drawerOpened = true;
      this.openedSales = sales;
      if (sales.price) {
        this.price = sales.price.price;
      }
      if (sales.estAging) {
        this.estAging = sales.estAging;
      }
      if (sales.transDist) {
        this.transDist = sales.transDist;
      }

      this.tableLoading = true;
      await this.getSalesPrice({ sales: sales._id });
      const saveCurrentPromoFeeList = await this.getCurrentPromoFee({
        id: sales._id
      });
      this.saveCurrentPromoFeeList = saveCurrentPromoFeeList.promoFeeList;
      await this.getSalesPromoFee({ sales: sales._id });
      await this.getSalesTransPrice({ sales: sales._id });
      this.tableLoading = false;
      // this.$refs["formItem"].resetFields();
      // this.loadPurchases(material);
    },

    // 添加费用集合
    async addPrice(cost) {
      switch (cost) {
        case "sales":
          if (this.salePrice) {
            const startActiveDate = dayjs(new Date()).format(
              "YYYY-MM-DD HH:mm"
            );
            const form = {};
            form.sales = this.openedSales._id;
            form.startActiveDate = startActiveDate;
            form.price = this.salePrice;
            const data = await this.createSalesPrice({ form });
            this.price = data.price;
            this.salePrice = null;
          }
          break;
        case "trans":
          if (this.transPrice || this.transPrice == 0) {
            const startActiveDate = dayjs(new Date()).format(
              "YYYY-MM-DD HH:mm"
            );
            const form = {};
            form.sales = this.openedSales._id;
            form.startActiveDate = startActiveDate;
            form.cost = this.transPrice;
            const data = await this.createSalesTransPrice({ form });
            this.transCost = data.rePrice;
            this.transPrice = null;
          }
          break;
      }
    },
    delPrice(id, type) {
      this.delId = id;
      this.delType = type;
      this.delPriceModel = true;
    },
    async delPriceMethod() {
      switch (this.delType) {
        case "salesPrice":
          try {
            await this.deleteSalesPrice({ id: this.delId });
            this.$Message.success("删除成功");
          } catch (error) {
            this.$Message.error("删除失败，" + error);
          }
          break;
        case "transPrice":
          try {
            await this.deleteTransCost({ id: this.delId });
            this.$Message.success("删除成功");
          } catch (error) {
            this.$Message.error("删除失败，" + error);
          }
          break;
      }
      this.delId = undefined;
      this.delType = undefined;
    },
    cancelDel() {
      this.delId = undefined;
    },
    addPromoFee(e) {
      switch (e) {
        case "fee":
          this.addPromoFeeRecordModal = true;
          break;
        case "contact":
          this.addCustomerContactModal = true;
          break;
      }
    },
    // 打开业务费设置
    async showSetPromoFeeModal() {
      const data = await this.getCustomerContact({
        customer: this.openedSales.customer._id
      });
      this.isShowSetPromoFeeModal = true;
    },
    // 保存业务费的设置
    async setPromoFee() {
      const data = {};
      data.promoFee = this.choosedPromoFee;
      const id = this.openedSales._id;
      await this.setActivcePromoFee({ id, data });
      await this.getCurrentPromoFee({ id });
      this.isShowSetPromoFeeModal = false;
      this.savePromoFeeSum = null;
      this.$Message.success("添加成功");
    },
    async addCustomerContact() {
      if (this.customerContact) {
        const form = {};
        form.customer = this.openedSales.customer._id;
        form.name = this.customerContact;
        await this.createCustomerContact({ form });
        this.$Message.success("添加成功");
      }
      this.customerContact = "";
    },
    // 添加业务费列表
    async addPromoFeeRecord() {
      if (this.selectCustomerContact && this.promoFee) {
        const form = {};
        form.fee = this.promoFee;
        form.customerContact = this.selectCustomerContact;
        form.sales = this.openedSales._id;
        await this.createSalesPromoFeeRecord({ form });
        this.$Message.success("添加成功");
      }
      this.customerContact = "";
      this.promoFee = undefined;
    },
    choosePromoFee(choosedPromoFee) {
      this.choosedPromoFee = choosedPromoFee;
      this.saveCurrentPromoFeeList = choosedPromoFee;
      this.savePromoFeeSum = choosedPromoFee
        .reduce((p, c) => {
          return p + c.fee;
        }, 0)
        .toString();
    },
    cancel() {},
    async setEstAging() {
      const form = { data: {} };
      form.id = this.openedSales._id;
      form.data.estAging = this.estAging;
      try {
        await this.updateSales(form);
        this.$Message.success("设置账龄成功");
      } catch (error) {
        this.$Message.error("设置账龄失败" + error);
      }
    },
    async setTransDist() {
      const form = { data: {} };
      form.id = this.openedSales._id;
      form.data.transDist = this.transDist;
      try {
        await this.updateSales(form);
        this.$Message.success("设置运距成功");
      } catch (error) {
        this.$Message.error("设置运距失败" + error);
      }
    },
    async setRemark() {
      const form = { data: {} };
      form.id = this.openedSales._id;
      form.data.remark = this.remark;
      try {
        await this.updateSales(form);
        this.$Message.success("设置备注成功");
      } catch (error) {
        this.$Message.error("设置备注失败" + error);
      }
    },
    closeDrawer() {
      this.transCost = null;
      this.transPrice = null;
      this.price = null;
      this.salePrice = null;
      this.estAging = null;
      this.transDist = null;
    }
  }
};
</script>

<style scoped lang="stylus">
.currentCost
  display flex

  .price
    font-size 20px

  .cost
    margin-right 60px

.title
  font-size 22px
  margin 15px 0 0 15px

.dashed
  width 100%
  height 1px
  border dashed 1px #D0D0D0
  margin 20px 0

.cost-records
  width 100%
  display flex
  font-size 16px
  overflow hidden
  flex-wrap wrap
  justify-content space-between

  .table
    margin-bottom 20px

.top
  display flex
  justify-content space-between

.remark
  display flex
  justify-content space-between
  align-items flex-end

.table-wrapper
  width 400px
  margin-top 15px
  height 300px

.modal-wrap
  display flex
  justify-content space-between
  height 400px

  .modalTitle
    display flex
    justify-content space-between
    font-size 18px
    margin-bottom 15px

.estAging-wrap
  width 400px

.deleteBtn
  cursor pointer

  &:hover
    color red
</style>